export const paginatorConstants = {
  PAGINATOR_LIST: "PAGINATOR_LIST",
  PAGINATOR_PAG_SELECT: "PAGINATOR_PAG_SELECT",
  PAGINATOR_PAG_SEARCH: "PAGINATOR_PAG_SEARCH",
  PAGINATOR_SUCCESS: "PAGINATOR_SUCCESS",
  PAGINATOR_NOT_SUCCESS: "PAGINATOR_NOT_SUCCESS",
  PAGINATOR_PAG_SELECT_RESET: "PAGINATOR_PAG_SELECT_RESET"
};
